import styled from 'styled-components';

import { scale030 } from '@xing-com/tokens';

export const Separator = styled.span`
  margin: 0 ${scale030};
`;
